import { applyErrorMiddlewares, applyRequestMiddlewares, applyResponseMiddlewares } from "./middleware.util";
import type { Middleware } from "./middleware.util";

function createCustomFetch(middlewares: Middleware[]) {
  // function fetch(input: RequestInfo | URL, init?: RequestInit): Promise<Response> (+2 overloads)

  return async (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
    try {
      // Apply request middlewares
      const [url, modifiedInit] = await applyRequestMiddlewares(middlewares, input, init);

      // Make the fetch request
      let response = await fetch(url, modifiedInit);

      if (!response.ok) {
        throw response;
      }

      // Apply response middlewares
      response = await applyResponseMiddlewares(middlewares, response);

      return response;
    } catch (error) {
      // Apply error middlewares and rethrow the error to maintain the function's contract
      await applyErrorMiddlewares(middlewares, error);
      throw error; // Rethrow the error after middleware processing
    }
  };
}
export default createCustomFetch;
